import { client } from './api';

class AdminService {
  fetchAllLocations = () => client.get('Location');

  fetchUsers = async (pageNumber = 1, itemsPerPage = 30, fetchAll = false, dataset = null) => {
    let set = dataset;
    if (!set) {
      set = { data: { pageContent: [], itemsPerPage, totalItems: 0, pageNumber }, status: null };
    }
    const res = await client.get(`Admin/Users?ItemsPerPage=${itemsPerPage}&PageNumber=${pageNumber}`);
    set.status = res.status;
    if (res && res.status === 200 && res.data.pageContent.length > 0) {
      res.data.pageContent.forEach(item => {
        set.data.pageContent.push(item);
      });
      if (fetchAll) {
        set = await this.fetchUsers(pageNumber + 1, itemsPerPage, fetchAll, set);
      }
    }
    return set;
  };
}

export default AdminService;
